export default __webpack_public_path__ + "static/media/bg_sign_up.9f2bc0d9.jpg";